import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import ExpandIcon from '@material-ui/icons/ExpandMore';
import ReportProblemIcon from '@material-ui/icons/ReportProblemOutlined';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import AccountsIcon from '@material-ui/icons/AccountBalanceOutlined';

import ReadOnlyBankField from './ReadOnlyBankField/ReadOnlyBankField';
import ArrangementHelp from './ArrangementHelp/ArrangementHelp';
import ArrangementSchedule from '../ArrangementSchedule/ArrangementSchedule';
import CalendarIcon from '../../../components/Icons/CalendarMonth/CalendarMonth';
import BaseDialog from '../../../components/BaseDialog/BaseDialog';
import LoaderProgress from '../../../components/Loader/LoaderProgress/LoaderProgress';
import DatePickerField from '../../../components/Fields/DatePickerField/DatePickerField';
import IndentedCardHeader from '../../../components/IndentedCardHeader/IndentedCardHeader';
import IndentedCardContent from '../../../components/IndentedCardContent/IndentedCardContent';
import ErrorDialog from '../../../components/ErrorDialog/ErrorDialog';
import ActionLink from '../../../components/ActionLink/ActionLink';
import ReplaceContact from '../../../components/Replace/ReplaceContact/ReplaceContact';
import ReplacePaymentSchedule from '../../../components/Replace/ReplacePaymentSchedule/ReplacePaymentSchedule';
import ReplaceArrangementTerms from '../../../components/Replace/ReplaceArrangementTerms/ReplaceArrangementTerms.js';

import { Formik, yupToFormErrors } from 'formik';
import { Wizard, Steps, Step } from 'react-albus';
import { find } from 'lodash-es';
import { object, string, number } from 'yup';
import dayjs from 'dayjs';

import 'flatpickr/dist/flatpickr.min.css';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

import {
  getString,
  stringToDateCompact,
  stringToDate,
  iPhoneFriendlyButtonLabel,
} from '../../../helpers/stringHelpers.js';
import {
  getArrangementEndDate,
  getArrangementInstallments,
} from '../../../helpers/arrangementHelpers.js';
import CardSpacer from '../../../components/CardSpacer/CardSpacer';
import constants from '../../../constants.js';

const stringsComponent = 'rentArrangements';

class CreateArrangementForm extends React.Component {
  constructor(props) {
    super(props);

    const { accountType, paymentReference } = props;

    this.state = {
      isLoading: false,
      calendarOpen: false,
      termsAgreed: false,
      scheduleOpen: false,
      termsOpen: false,
      dirty: false,
      selectedPaymentFrequency: '',
      formData: {
        paymentAmount: '',
        paymentMethod: '',
        paymentFrequencyCycle: '',
        dateDummy: '',
        paymentStartDate: '',
        accountType: accountType ? accountType : '',
        paymentRef: paymentReference ? paymentReference : '',
      },
    };

    this.handleTermsCheckboxChange = this.handleTermsCheckboxChange.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.toggleSchedule = this.toggleSchedule.bind(this);
    this.toggleTerms = this.toggleTerms.bind(this);
  }

  componentDidUpdate() {
    const { setUnsaved } = this.props;

    const { dirty } = this.state;
    //const { hasError } = this.state;
    if (dirty) {
      setUnsaved(true);
    } else {
      setUnsaved(false);
    }
  }

  handleFieldChange() {
    const { dirty } = this.state;

    if (dirty === false) {
      this.setState({ dirty: true });
    }
  }

  handleTermsCheckboxChange() {
    this.setState({
      termsAgreed: !this.state.termsAgreed,
    });
  }

  toggleSchedule() {
    this.setState({
      scheduleOpen: !this.state.scheduleOpen,
    });
  }

  toggleTerms() {
    this.setState({
      termsOpen: !this.state.termsOpen,
    });
  }

  scrollToTop() {
    window.scrollTo(0, 0);
  }

  buildCardHeader(title) {
    const { classes } = this.props;
    return (
      <IndentedCardHeader
        title={<Typography variant="h3">{title}</Typography>}
        avatar={<AccountsIcon />}
        classes={{
          avatar: classes.avatar,
        }}
      />
    );
  }

  buildSelectField(
    name,
    label,
    placeholder,
    changeHandler,
    value,
    optionsFunction,
    setFieldValue
  ) {
    const { classes, balance } = this.props;

    const options = optionsFunction();
    const friendlyValue = value
      ? find(optionsFunction(), { value: value }).label
      : null;

    return (
      <div className={classes.fieldContainer}>
        <Typography className={classes.label}>
          <label htmlFor={name}>{label}</label>
        </Typography>
        <Select
          onChange={(event) => {
            changeHandler(event);
            // If the frequency field changes, we also change the amount field.
            const value = event.target.value;
            if (name == 'paymentFrequencyCycle') {
              if (value == 'One') {
                // One off payment amount must be the full balance.
                setFieldValue('paymentAmount', Math.abs(balance));
              } else if (this.state.selectedPaymentFrequency != value) {
                // Otherwise if the frequency was changed, reset the amount.
                setFieldValue(
                  'paymentAmount',
                  this.getMinimumPaymentAmount(
                    this.getMinimumPaymentMultiplier(value)
                  )
                );
              }
              this.setState({ selectedPaymentFrequency: value });
            }
          }}
          value={value}
          input={<OutlinedInput name={name} id={name} labelWidth={0} />}
          displayEmpty
          renderValue={(value) => (value ? friendlyValue : placeholder)}
          onBlur={this.handleFieldChange}
          fullWidth
          MenuProps={{
            classes: {
              paper: classes.selectMenu,
            },
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            getContentAnchorEl: null,
          }}
          inputProps={{
            className: value
              ? classes.selectInput
              : `${classes.selectInput} ${classes.selectDisabled}`,
          }}
          IconComponent={ExpandIcon}
        >
          {options.map((option, i) => {
            return (
              <MenuItem key={i} value={option.value}>
                {option.label}
              </MenuItem>
            );
          })}
        </Select>
      </div>
    );
  }

  buildButtons(
    submitHandler,
    previous = null,
    isValid = true,
    nextButtonLabel = 'Next',
    showCancel = true,
    submissionStep = false
  ) {
    const { classes, gaEvent, cancelAction } = this.props;
    return (
      <Grid container className={classes.buttons}>
        <Grid item xs={4}>
          {showCancel && (
            <Button variant="outlined" onClick={cancelAction}>
              {getString('app', 'CANCEL_LABEL')}
            </Button>
          )}
        </Grid>
        <Grid item xs={8} className={classes.buttonsRight}>
          <React.Fragment>
            {previous && (
              <Button
                variant="outlined"
                onClick={() => {
                  previous();
                  this.scrollToTop();
                }}
                className={'backButton'}
              >
                {getString('app', 'BACK_LABEL')}
              </Button>
            )}
            <Button
              variant="outlined"
              color="primary"
              onClick={() => {
                submitHandler();
                this.scrollToTop();
                submissionStep &&
                  gaEvent(
                    'Rent Arrangement',
                    'Create',
                    'Complete arrangement creation'
                  );
              }}
              disabled={!isValid}
              className={classes.buttonNext}
            >
              {iPhoneFriendlyButtonLabel(nextButtonLabel, !isValid)}
            </Button>
          </React.Fragment>
        </Grid>
      </Grid>
    );
  }

  /**
   * Build radio button form .
   * @param {string} cardTitle Card/form title.
   * @returns {Object}
   */
  buildForm(cardTitle, cardContent, next, previous = null) {
    const { classes } = this.props;

    return (
      <React.Fragment>
        {this.buildCardHeader(cardTitle)}
        <IndentedCardContent
          body={
            <div className={classes.negativeTopMargin}>
              <Divider />
              {cardContent}
            </div>
          }
        />
      </React.Fragment>
    );
  }

  getPaymentMethods() {
    return [
      {
        value: 'Automatic payment',
        label: getString(stringsComponent, 'AUTOMATIC_PAYMENT_LABEL'),
      },
      {
        value: 'Bank deposit',
        label: getString(stringsComponent, 'BANK_DEPOSIT_LABEL'),
      },
      {
        value: 'Internet banking',
        label: getString(stringsComponent, 'INTERNET_BANKING_LABEL'),
      },
    ];
  }

  getPaymentFrequencies() {
    return [
      { value: 'One', label: getString(stringsComponent, 'ONE_OFF_LABEL') },
      { value: 'Weeks', label: getString(stringsComponent, 'WEEKLY_LABEL') },
      {
        value: 'Fortnightly',
        label: getString(stringsComponent, 'FORTNIGHTLY_LABEL'),
      },
      { value: 'Months', label: getString(stringsComponent, 'MONTHLY_LABEL') },
    ];
  }

  getMinimumPaymentMultiplier(frequency) {
    switch (frequency) {
      case 'Weeks':
        return 1;
      case 'Fortnightly':
        return 2;
      case 'Months':
        return 4;
      default:
        return 0;
    }
  }

  getMinimumPaymentAmount(minimumMultiplier = 1) {
    const { account, accountType } = this.props;

    const minimumPaymentPercentage =
      portalSettings.RENT_ARRANGEMENTS_MINIMUM_REPAYMENT_PERCENTAGE;
    const minimumPaymentValue =
      portalSettings.RENT_ARRANGEMENTS_MINIMUM_REPAYMENT;

    // Calculate the minimum payment amount using the minimum payment percentage (of rent)
    // If the percentage is under the minimum payment value, use the value instead
    let minimumPaymentAmount = minimumPaymentValue;
    if (accountType == 'rent' && minimumPaymentPercentage) {
      const rentAmount = account.data.accounts.rent.currentRentChargeAmount;
      minimumPaymentAmount = Math.floor(
        rentAmount * (minimumPaymentPercentage / 100)
      );
      if (minimumPaymentAmount < minimumPaymentValue) {
        minimumPaymentAmount = minimumPaymentValue;
      }
    }

    return minimumPaymentAmount * minimumMultiplier;
  }

  getAmountValidationSchema(minimumMultiplier = 1) {
    const { balance } = this.props;

    const minimumPaymentAmount =
      this.getMinimumPaymentAmount(minimumMultiplier);

    const maximumPaymentAmount = Math.abs(balance);

    const amountRegex = /^[0-9]*(\.[0-9]{0,2})?$/;

    return number()
      .typeError(getString(stringsComponent, 'AMOUNT_TYPE_ERROR'))
      .required(getString(stringsComponent, 'AMOUNT_REQUIRED_ERROR'))
      .test(
        'valid-amount',
        getString(stringsComponent, 'AMOUNT_REGEX_ERROR'),
        (paymentAmount) => {
          return (
            amountRegex.test(paymentAmount) &&
            paymentAmount >= minimumPaymentAmount &&
            paymentAmount <= maximumPaymentAmount
          );
        }
      );
  }

  renderInfoStep(next) {
    const { classes, contactAction } = this.props;
    const { termsOpen } = this.state;

    const cardContent = (
      <React.Fragment>
        <br />
        <Typography
          component="div"
          className={`${classes.documentStyle} ${classes.dialogContent}`}
        >
          <ReplaceArrangementTerms
            content={portalContent.NEW_ARRANGEMENTS_OVERVIEW}
            action={this.toggleTerms}
          />
        </Typography>
        <Divider />
        {this.buildButtons(next, null, true, getString('app', 'NEXT_LABEL'))}
        <BaseDialog
          open={termsOpen}
          icon={ReportProblemIcon}
          buttonAction={this.toggleTerms}
          buttonLabel={getString('app', 'CLOSE_LABEL')}
          title={getString('arrangements', 'TERMS_DIALOG_TITLE')}
          content={
            <ReplaceContact
              content={portalContent.ARRANGEMENTS_TERMS}
              action={contactAction}
              isLink={true}
            />
          }
          contentWrap={false}
          isHTML={true}
        />
      </React.Fragment>
    );

    return this.buildForm(
      getString(stringsComponent, 'STEP_1_TITLE'),
      cardContent,
      next
    );
  }

  renderDetailsStep(next, previous) {
    const {
      classes,
      balance,
      nextPaymentAmount,
      nextPaymentDate,
      cancelAction,
      contactAction,
    } = this.props;

    const { formData } = this.state;

    const initialValues = formData;

    const validationSchema = object().shape({
      paymentMethod: string().required(
        getString(stringsComponent, 'METHOD_ERROR')
      ),
      paymentFrequencyCycle: string().required(
        getString(stringsComponent, 'FREQUENCY_ERROR')
      ),
      paymentAmount: number()
        .when('paymentFrequencyCycle', {
          is: 'Months',
          then: this.getAmountValidationSchema(4),
          otherwise: this.getAmountValidationSchema(),
        })
        .when('paymentFrequencyCycle', {
          is: 'Fortnightly',
          then: this.getAmountValidationSchema(2),
          otherwise: this.getAmountValidationSchema(),
        }),
      paymentStartDate: string().required(
        getString(stringsComponent, 'DATE_ERROR')
      ),
    });

    const cardContent = (
      <React.Fragment>
        <Typography className={classes.introText}>
          {getString(stringsComponent, 'PAYMENT_DETAILS_INTRO_TEXT')}
        </Typography>
        <Grid container>
          <Grid item xs={12} sm={10} md={12} lg={9} xl={6}>
            <Divider />
            <Grid container>
              <Grid item xs={10} className={classes.gridItem}>
                <Typography className={classes.label}>
                  {getString(stringsComponent, 'NEXT_PAYMENT_DUE_LABEL') + ' '}
                  <span className={classes.subLabel}>
                    | {stringToDate(nextPaymentDate)}
                  </span>
                </Typography>
              </Grid>
              <Grid
                item
                xs={2}
                className={`${classes.gridItem} ${classes.gridItemRight}`}
              >
                <Typography className={classes.label}>
                  ${nextPaymentAmount}
                </Typography>
              </Grid>
            </Grid>
            <Divider />
            <Grid container>
              <Grid item xs={9} className={classes.gridItem}>
                <Typography className={classes.label}>
                  {getString(stringsComponent, 'TOTAL_LABEL')}
                </Typography>
              </Grid>
              <Grid
                item
                xs={3}
                className={`${classes.gridItem} ${classes.gridItemRight}`}
              >
                <Typography className={classes.label}>
                  ${Math.abs(balance)}
                </Typography>
              </Grid>
            </Grid>
            <Divider />
          </Grid>
        </Grid>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          isInitialValid={validationSchema.isValidSync(initialValues)}
          onSubmit={(values, { setSubmitting }) => {
            this.setState({ formData: values });
            next();
          }}
        >
          {(props) => {
            const {
              handleChange,
              handleSubmit,
              setFieldValue,
              isValid,
              values,
              errors,
            } = props;
            return (
              <form>
                <input
                  type="hidden"
                  name="accountType"
                  value={values.accountType}
                />
                <input
                  type="hidden"
                  name="paymentRef"
                  value={values.paymentRef}
                />
                <Grid container>
                  <Grid
                    item
                    xs={12}
                    sm={10}
                    md={12}
                    lg={9}
                    xl={6}
                    className={classes.fieldsContainer}
                  >
                    {this.buildSelectField(
                      'paymentMethod',
                      getString(stringsComponent, 'METHOD_LABEL'),
                      getString(stringsComponent, 'METHOD_PLACEHOLDER'),
                      handleChange,
                      values.paymentMethod,
                      this.getPaymentMethods,
                      setFieldValue
                    )}
                    {this.buildSelectField(
                      'paymentFrequencyCycle',
                      getString(stringsComponent, 'FREQUENCY_LABEL'),
                      getString(stringsComponent, 'FREQUENCY_PLACEHOLDER'),
                      handleChange,
                      values.paymentFrequencyCycle,
                      this.getPaymentFrequencies,
                      setFieldValue
                    )}
                    <div className={classes.fieldContainer}>
                      <Typography className={classes.label}>
                        <label htmlFor="paymentAmount">
                          {getString(stringsComponent, 'AMOUNT_LABEL')}
                        </label>
                      </Typography>
                      <TextField
                        variant="outlined"
                        id="paymentAmount"
                        name="paymentAmount"
                        value={values.paymentAmount}
                        onChange={handleChange}
                        error={
                          values.paymentAmount != '' &&
                          Boolean(errors.paymentAmount)
                        }
                        helperText={
                          values.paymentAmount != '' &&
                          errors.paymentAmount && (
                            <ReplaceContact
                              content={errors.paymentAmount}
                              action={contactAction}
                              isLink={true}
                            />
                          )
                        }
                        placeholder="$0.00"
                        inputProps={{
                          className: classes.textInput,
                        }}
                        onBlur={this.handleFieldChange}
                        disabled={values.paymentFrequencyCycle === 'One'}
                        fullWidth
                      />
                    </div>
                    <div className={classes.fieldContainer}>
                      <Typography className={classes.label}>
                        <label htmlFor="paymentStartDate">
                          {getString(stringsComponent, 'DATE_LABEL')}
                        </label>
                      </Typography>
                      <DatePickerField
                        fieldName="paymentStartDate"
                        value={
                          values.paymentStartDate
                            ? stringToDateCompact(values.paymentStartDate)
                            : ''
                        }
                        changeHandler={setFieldValue}
                        placeholder={getString(
                          stringsComponent,
                          'DATE_PLACEHOLDER'
                        )}
                        minDate={dayjs()
                          .add(
                            portalSettings.ARRANGEMENTS_DATE_MINIMUM_DAYS,
                            'day'
                          )
                          .toDate()}
                        maxDate={dayjs()
                          .add(
                            portalSettings.ARRANGEMENTS_DATE_MAXIMUM_DAYS,
                            'day'
                          )
                          .toDate()}
                      />
                    </div>
                  </Grid>
                </Grid>
                <Divider />
                {this.buildButtons(
                  handleSubmit,
                  previous,
                  isValid,
                  getString('app', 'NEXT_LABEL')
                )}
              </form>
            );
          }}
        </Formik>
      </React.Fragment>
    );
    return this.buildForm(
      getString(stringsComponent, 'STEP_2_TITLE'),
      cardContent,
      next,
      previous
    );
  }

  renderReviewStep(next, previous) {
    const { classes, balance, contactAction, setUnsaved } = this.props;

    const { formData, termsAgreed, scheduleOpen, termsOpen } = this.state;

    const cardContent = (
      <React.Fragment>
        <Typography className={classes.introText}>
          {getString(stringsComponent, 'PAYMENT_REVIEW_INTRO_TEXT')}
        </Typography>
        <Grid container>
          <Grid item xs={12} sm={10} md={12} lg={9} xl={6}>
            <Divider />
            <Grid container>
              <Grid item xs={6} className={classes.gridItem}>
                <Typography className={classes.label}>
                  {getString(stringsComponent, 'TOTAL_LABEL')}
                </Typography>
              </Grid>
              <Grid
                item
                xs={6}
                className={`${classes.gridItem} ${classes.gridItemRight}`}
              >
                <Typography className={classes.label}>
                  ${Math.abs(balance)}
                </Typography>
              </Grid>
            </Grid>
            <Divider />
            <div className={classes.gridItem}>
              <Typography className={classes.label}>
                {getString(stringsComponent, 'METHOD_LABEL')}
              </Typography>
              <Typography>
                {
                  find(this.getPaymentMethods(), {
                    value: formData.paymentMethod,
                  }).label
                }
              </Typography>
            </div>

            <Divider />
            <Grid container>
              <Grid item xs={6} className={classes.gridItem}>
                <Typography className={classes.label}>
                  {getString(stringsComponent, 'FREQUENCY_SHORT_LABEL')}
                </Typography>
                <Typography>
                  {
                    find(this.getPaymentFrequencies(), {
                      value: formData.paymentFrequencyCycle,
                    }).label
                  }
                </Typography>
              </Grid>
              <Grid
                item
                xs={6}
                className={`${classes.gridItem} ${classes.gridItemRight}`}
              >
                <Typography className={classes.label}>
                  {getString(stringsComponent, 'PAYMENT_AMOUNT_LABEL')}
                </Typography>
                <Typography>${formData.paymentAmount}</Typography>
              </Grid>
            </Grid>
            <Divider />
            <Grid container>
              <Grid item xs={6} className={classes.gridItem}>
                <Typography className={classes.label}>
                  {getString(stringsComponent, 'REVIEW_START_DATE_LABEL')}
                </Typography>
                <Typography>
                  {stringToDateCompact(formData.paymentStartDate)}
                </Typography>
              </Grid>
              <Grid
                item
                xs={6}
                className={`${classes.gridItem} ${classes.gridItemRight}`}
              >
                <Typography className={classes.label}>
                  {getString(stringsComponent, 'REVIEW_END_DATE_LABEL')}
                </Typography>
                <Typography>
                  {stringToDateCompact(
                    getArrangementEndDate(
                      formData.paymentStartDate,
                      Math.abs(balance),
                      formData.paymentAmount,
                      formData.paymentFrequencyCycle
                    )
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Divider />
          </Grid>
        </Grid>
        <div className={classes.largeSection}>
          <Typography className={classes.paymentLinkText}>
            <CalendarIcon
              onClick={this.toggleSchedule}
              className={classes.scheduleIcon}
            />
            <ReplacePaymentSchedule
              content={getString(stringsComponent, 'PAYMENT_SCHEDULE_TEXT')}
              action={this.toggleSchedule}
            />
          </Typography>
        </div>
        <Divider />
        <div className={classes.largeSection}>
          <FormControlLabel
            control={
              <Checkbox
                defaultChecked={termsAgreed}
                name="terms-agreed"
                onChange={this.handleTermsCheckboxChange}
                className={classes.termsCheckbox}
              />
            }
            label={getString(stringsComponent, 'TERMS_CHECKBOX_LABEL')}
            className={classes.checkboxLabel}
          />
          <Typography className={classes.arrangementTermsText}>
            <ReplaceArrangementTerms
              content={`$ArrangementTerms`}
              action={this.toggleTerms}
            />
          </Typography>
        </div>
        <Divider />
        <Typography
          className={`${classes.largeSectionLast} ${classes.createArrangementText}`}
        >
          {getString(stringsComponent, 'CREATE_ARRANGEMENT_TEXT')}
        </Typography>
        {this.buildButtons(
          () => {
            this.setState({ dirty: false });
            next();
            this.props.createArrangement(formData);
          },
          previous,
          termsAgreed,
          getString('app', 'CONFIRM_LABEL'),
          true,
          true
        )}
        <ArrangementSchedule
          open={scheduleOpen}
          handleClose={this.toggleSchedule}
          items={getArrangementInstallments(
            formData.paymentStartDate,
            Math.abs(balance),
            Number(formData.paymentAmount),
            formData.paymentFrequencyCycle
          )}
          balance={Math.abs(balance)}
        />
        <BaseDialog
          open={termsOpen}
          icon={ReportProblemIcon}
          buttonAction={this.toggleTerms}
          buttonLabel={getString('app', 'CLOSE_LABEL')}
          title={getString('arrangements', 'TERMS_DIALOG_TITLE')}
          content={
            <ReplaceContact
              content={portalContent.ARRANGEMENTS_TERMS}
              action={contactAction}
              isLink={true}
            />
          }
          contentWrap={false}
          isHTML={true}
        />
      </React.Fragment>
    );
    return this.buildForm(
      getString(stringsComponent, 'STEP_3_TITLE'),
      cardContent,
      next,
      previous
    );
  }

  renderConfirmStep(next, previous) {
    const {
      classes,
      balance,
      paymentReference,
      customerReference,
      newArrangementState,
      finishAction,
    } = this.props;

    const { formData } = this.state;

    const cardContent = newArrangementState == constants.STATE_SUCCESS && (
      <React.Fragment>
        <Typography className={classes.introText}>
          {getString(stringsComponent, 'PAYMENT_CONFIRMED_INTRO_TEXT')}
        </Typography>
        <Grid container>
          <Grid item xs={12} xl={11}>
            <ArrangementHelp
              title={getString(stringsComponent, 'HELP_TITLE')}
              content={portalContent.ARRANGEMENTS_HELP_CONTENT.replaceAll(
                '$PaymentReference',
                paymentReference
              ).replaceAll('$CustomerReference', customerReference)}
            />
            <br />
            <Card className="Card">
              <CardContent className={classes.subCard}>
                <Typography className={classes.subCardHeading}>
                  {getString(
                    stringsComponent,
                    'YOUR_ARRANGEMENT_DETAILS_TITLE'
                  )}
                </Typography>
                <Divider className={classes.subCardHeadingDivider} />
                <Hidden xlUp>
                  <Grid container>
                    <Grid item xs={6} className={classes.gridItem}>
                      <Typography className={classes.label}>
                        {getString(stringsComponent, 'TOTAL_LABEL')}
                      </Typography>
                      <Typography>${Math.abs(balance)}</Typography>
                    </Grid>
                    <Grid item xs={6} className={classes.gridItem}>
                      <Typography className={classes.label}>
                        {getString(stringsComponent, 'METHOD_LABEL')}
                      </Typography>
                      <Typography>
                        {
                          find(this.getPaymentMethods(), {
                            value: formData.paymentMethod,
                          }).label
                        }
                      </Typography>
                    </Grid>
                  </Grid>
                  <Divider />
                  <Grid container>
                    <Grid item xs={6} className={classes.gridItem}>
                      <Typography className={classes.label}>
                        {getString(stringsComponent, 'FREQUENCY_SHORT_LABEL')}
                      </Typography>
                      <Typography>
                        {
                          find(this.getPaymentFrequencies(), {
                            value: formData.paymentFrequencyCycle,
                          }).label
                        }
                      </Typography>
                    </Grid>
                    <Grid item xs={6} className={classes.gridItem}>
                      <Typography className={classes.label}>
                        {getString(stringsComponent, 'PAYMENT_AMOUNT_LABEL')}
                      </Typography>
                      <Typography>${formData.paymentAmount}</Typography>
                    </Grid>
                  </Grid>
                  <Divider />
                  <Grid container>
                    <Grid item xs={6} className={classes.gridItem}>
                      <Typography className={classes.label}>
                        {getString(stringsComponent, 'REVIEW_START_DATE_LABEL')}
                      </Typography>
                      <Typography>
                        {stringToDateCompact(formData.paymentStartDate)}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} className={classes.gridItem}>
                      <Typography className={classes.label}>
                        {getString(stringsComponent, 'REVIEW_END_DATE_LABEL')}
                      </Typography>
                      <Typography>
                        {stringToDateCompact(
                          getArrangementEndDate(
                            formData.paymentStartDate,
                            Math.abs(balance),
                            formData.paymentAmount,
                            formData.paymentFrequencyCycle
                          )
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                </Hidden>
                <Hidden lgDown>
                  <Grid container>
                    <Grid item xs={4} className={classes.gridItem}>
                      <Typography className={classes.label}>
                        {getString(stringsComponent, 'FREQUENCY_SHORT_LABEL')}
                      </Typography>
                      <Typography>
                        {
                          find(this.getPaymentFrequencies(), {
                            value: formData.paymentFrequencyCycle,
                          }).label
                        }
                      </Typography>
                    </Grid>
                    <Grid item xs={4} className={classes.gridItem}>
                      <Typography className={classes.label}>
                        {getString(stringsComponent, 'TOTAL_LABEL')}
                      </Typography>
                      <Typography>${Math.abs(balance)}</Typography>
                    </Grid>
                    <Grid item xs={4} className={classes.gridItem}>
                      <Typography className={classes.label}>
                        {getString(stringsComponent, 'METHOD_LABEL')}
                      </Typography>
                      <Typography>
                        {
                          find(this.getPaymentMethods(), {
                            value: formData.paymentMethod,
                          }).label
                        }
                      </Typography>
                    </Grid>
                  </Grid>
                  <Divider />
                  <Grid container>
                    <Grid item xs={4} className={classes.gridItem}>
                      <Typography className={classes.label}>
                        {getString(stringsComponent, 'PAYMENT_AMOUNT_LABEL')}
                      </Typography>
                      <Typography>${formData.paymentAmount}</Typography>
                    </Grid>
                    <Grid item xs={4} className={classes.gridItem}>
                      <Typography className={classes.label}>
                        {getString(stringsComponent, 'REVIEW_START_DATE_LABEL')}
                      </Typography>
                      <Typography>
                        {stringToDateCompact(formData.paymentStartDate)}
                      </Typography>
                    </Grid>
                    <Grid item xs={4} className={classes.gridItem}>
                      <Typography className={classes.label}>
                        {getString(stringsComponent, 'REVIEW_END_DATE_LABEL')}
                      </Typography>
                      <Typography>
                        {stringToDateCompact(
                          getArrangementEndDate(
                            formData.paymentStartDate,
                            Math.abs(balance),
                            formData.paymentAmount,
                            formData.paymentFrequencyCycle
                          )
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                </Hidden>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <CardSpacer />
        <Grid container>
          <Grid item xs={12} xl={11}>
            <Card className="Card">
              <CardContent className={classes.subCard}>
                <Typography className={classes.subCardHeading}>
                  {getString(stringsComponent, 'PAYEE_TITLE')}
                </Typography>
                <Divider className={classes.subCardHeadingDivider} />
                <Grid container>
                  <Grid item xs={12} sm={6} xl={4} className={classes.gridItem}>
                    <Typography className={classes.label}>
                      {getString(stringsComponent, 'PAYEE_LABEL')}
                    </Typography>
                    <Typography>
                      {getString(stringsComponent, 'PAYEE_VALUE')}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} xl={4} className={classes.gridItem}>
                    <Typography className={classes.label}>
                      {getString(stringsComponent, 'REFERENCE_LABEL')}
                    </Typography>
                    <Typography>{paymentReference}</Typography>
                  </Grid>
                  <Hidden lgDown>
                    <Grid item xl={4}>
                      &nbsp;
                    </Grid>
                  </Hidden>
                </Grid>
                <Divider />
                <div className={classes.gridItem}>
                  <Typography className={classes.label}>
                    {getString(stringsComponent, 'ACCOUNT_NUMBER_LABEL')}
                  </Typography>
                  <ReadOnlyBankField
                    bank={getString(stringsComponent, 'KO_BANK_NUMBER')}
                    branch={getString(stringsComponent, 'KO_BRANCH_NUMBER')}
                    accountNumber={getString(
                      stringsComponent,
                      'KO_ACCOUNT_NUMBER'
                    )}
                    suffix={getString(stringsComponent, 'KO_SUFFIX_NUMBER')}
                  />
                </div>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        {this.buildButtons(
          finishAction,
          null,
          true,
          getString(stringsComponent, 'FINISH_LABEL'),
          false
        )}
      </React.Fragment>
    );

    return this.buildForm(
      getString(stringsComponent, 'STEP_4_TITLE'),
      cardContent,
      next,
      previous
    );
  }

  render() {
    const { classes, onError, failureText, newArrangementState } = this.props;

    return (
      <div className="App">
        <Card className="Card">
          <LoaderProgress
            show={newArrangementState == constants.STATE_CREATING}
          />
          {newArrangementState == constants.STATE_FAIL && (
            <ErrorDialog logout={onError} text={failureText} />
          )}

          <Wizard>
            <Steps>
              <Step
                id="info"
                render={({ next }) => this.renderInfoStep(next)}
              />
              <Step
                id="details"
                render={({ next, previous }) =>
                  this.renderDetailsStep(next, previous)
                }
              />
              <Step
                id="review"
                render={({ next, previous }) =>
                  this.renderReviewStep(next, previous)
                }
              />
              <Step
                id="confirm"
                render={({ next, previous }) =>
                  this.renderConfirmStep(next, previous)
                }
              />
            </Steps>
          </Wizard>
        </Card>
      </div>
    );
  }
}

CreateArrangementForm.propTypes = {
  classes: PropTypes.object.isRequired,
  onError: PropTypes.func.isRequired,
  failureText: PropTypes.object.isRequired,
  setUnsaved: PropTypes.func.isRequired,
  contactAction: PropTypes.func.isRequired,
  gaEvent: PropTypes.func.isRequired,
  balance: PropTypes.number,
  nextPaymentAmount: PropTypes.number,
  nextPaymentDate: PropTypes.string,
  paymentReference: PropTypes.string,
  accountType: PropTypes.string.isRequired,
  customerReference: PropTypes.string.isRequired,
  cancelAction: PropTypes.func.isRequired,
  finishAction: PropTypes.func.isRequired,
};

CreateArrangementForm.defaultProps = {
  balance: null,
  nextPaymentAmount: null,
  nextPaymentDate: null,
  paymentReference: '',
};

const mapStateToProps = (state) => ({
  tenancy: state.customer.tenancy,
  account: state.customer.account,
  newArrangementState: state.customer.newArrangementState,
});

export default connect(mapStateToProps)(
  withStyles(styles, { withTheme: true })(CreateArrangementForm)
);
